export type ExtensionStore = 'chrome' | 'edge' | 'unknown';

export function preferredExtensionStore(userAgent: string): ExtensionStore {
  if (/\bEdg(?:A|iOS)?\//i.test(userAgent)) return 'edge';
  if (/\b(?:Chrome|CriOS)\//i.test(userAgent)) return 'chrome';
  return 'unknown';
}
